import React, {Component} from 'react';
import Junk from "./steps/Junk";
import Size from "./steps/Size";
import Collection from "./steps/Collection";
import Confirmation from "./steps/Confirmation";
import Payment from "./steps/Payment";
import Loqateservice from './services/LoqateService';
import scrollToComponent from 'react-scroll-to-component';
import ReactDOM from 'react-dom';
import axios from "axios/index";
import HelpOurTeam from "./steps/HelpOurTeam";
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Loader from 'react-loader-spinner';


class Wizard extends Component {
    constructor(props) {
        super(props);

        this.Loqateservice = new Loqateservice();

        this.state = this.getStateFromLocalStorage();

        this.changeStep = this.changeStep.bind(this);
        this.goNextStep = this.goNextStep.bind(this);
        this.updateState = this.updateState.bind(this);
        this.setValidity = this.setValidity.bind(this);
        this.updateOrderPrices = this.updateOrderPrices.bind(this);
        this.changeVariation = this.changeVariation.bind(this);
        this.changeVariationAndGoNext = this.changeVariationAndGoNext.bind(this);
        this.transferToSkip = this.transferToSkip.bind(this);
        this.transferToManAndVan = this.transferToManAndVan.bind(this);
        this.toggleVariationModal = this.toggleVariationModal.bind(this);
        this.handleSelectPostcode = this.handleSelectPostcode.bind(this);
        this.handlePostcodeChange = this.handlePostcodeChange.bind(this);
    }

    componentDidMount() {
        console.log(this.props);
        if (this.props.variation === 'man_and_van') {
            console.log('man and wan');
            gtag('event', 'conversion', {'send_to': 'AW-703359936/YkMvCKb42s4BEMDXsc8C'});
        } else {
            console.log('ma wan else');
            gtag('event', 'conversion', {'send_to': 'AW-703359936/R5N4CKOezM4BEMDXsc8C'});
        }

        this.setState({
            data: true,
        });
    }

    toggleVariationModal() {
        this.setState(prevState => ({
            variation_modal: !prevState.variation_modal
        }));
    }

    changeVariation() {
        let addresses = this.state.availableAddresses;

        window.ga('send', 'event', 'wizard', 'wizard', 'Change to man and van');

        this.state.current_variation == 'man_and_van'
            ? this.transferToSkip(addresses)
            : this.transferToManAndVan(addresses);

        return this.state.current_variation;
    }

    changeVariationAndGoNext() {
        this.changeVariation();
        this.goNextStep();
    }

    transferToSkip(addresses) {
        this.setState(this.getDefaultState(),
            () => {
                let updateCartEvent = new CustomEvent('updateCart', {'detail': '0'});
                document.dispatchEvent(updateCartEvent);
                this.setState({
                        current_variation: 'skip',
                        availableAddresses: addresses,
                        data: true
                    },
                    () => sessionStorage.clear())
            })
    }

    transferToManAndVan(addresses) {
        this.setState((prevState) => ({
            current_variation: 'man_and_van',
            availableAddresses: addresses,
            variation_modal: false,
            junkState: {
                size: prevState.junkState.size !== '' ? prevState.junkState.size.relative : ''
            },
            helpState: {
                arrival: '',
                access: true,
                parking: true
            }
        }), () => this.updateOrderPrices())
    }

    updateState(pieceOfState, newPieceOfState) {
        let newState = Object.assign({}, this.state);
        newState[pieceOfState] = newPieceOfState;
        this.setState(newState, () => this.updateOrderPrices());
    }

    updateOrderPrices() {
        let junk = this.state.junkState.size.price || 0;
        // todo: this needs rework
        // let extras = this.state.sizeState.extras.filter((extra) => extra.qty).length
        //     ? this.state.sizeState.extras.filter((extra) => extra.qty).map(extra => extra.total_price*100).reduce((prev, next) => prev + next)
        //     : 0;
        let extras = 0;

        if (this.state.sizeState.selected_extras.length > 0) {
            let selected = [...this.state.sizeState.selected_extras];
            extras = selected.map(extra => extra.total_price * 100).reduce((prev, next) => prev + next);
        }

        let next_day = this.state.helpState.arrival.type == 'next_day' ? 1000 : 0;

        this.setState({
                order_total: (+junk) + (+extras) + (+next_day)
            }, () => {
                let updateCartEvent = new CustomEvent('updateCart', {'detail': this.state.order_total});
                document.dispatchEvent(updateCartEvent);
            }
        );
    }

    setValidity(step, value) {
        let steps = this.state.steps;
        steps[step].valid = value;
        this.setState({steps});
    }

    changeStep(index) {
        if (index <= 0) {
            this.setState({
                currentStep: 0,
                validationError: null
            }, () => {
                scrollToComponent(this.wizardStart, {offset: 0, align: 'top', duration: 20, ease: 'inExpo'});
            });
        } else if (index > 0 && this.state.steps[index - 1].valid) {
            this.setState({
                currentStep: index,
                validationError: null
            }, () => {
                sessionStorage.setItem('wizardState', JSON.stringify(this.state));
                scrollToComponent(this.wizardStart, {offset: 0, align: 'top', duration: 20, ease: 'inExpo'});
            });
        } else {
            this.setState({validationError: "Please fill all fields on this page to proceed"})
        }
    }

    updateModal() {
        this.setState({
            variation_modal: this.state.current_variation == 'skip'
        });
    }

    goNextStep() {
        this.setState({
            variation_modal: false
        }, () => {
            this.setState({
                currentStep: this.state.currentStep + 1
            })
        });
    }

    handleSelectPostcode(event) {
        event.preventDefault();
        const {postcode} = this.state;
        let err = {...this.state.errors};
        //  Check validation
        if (this.state.postcode || this.state.manualAddress.postcode) {
            //  Loader flag
            this.setState({loading: true});

            this.Loqateservice.getLocationId(this.state.postcode)
                .then(res => {
                    let container = res.data.Items[0]['Id'];
                    let postcode = this.state.postcode;
                    return axios.post('/addresses', {postcode, container})
                        .then(res => {
                            this.setState({
                                availableAddresses: res.data.Items,
                                data: true
                            })
                        })
                });

            if (this.checkIfUkPostcode(postcode)) {
                this.setState({postcodeValid: false});
                // this.LoqateService.getLocationId(postcode)
                //     .then(location => {
                //         let container = location.data.Items[0]['Id'];
                //         this.LoqateService.getAvailableAddressesNew(postcode, container)
                //             .then(address => {
                //                 this.setState({availableAddresses: address.data.Items, loading: false});
                //             })
                //             .catch(err => {
                //                 this.setState({loading: false});
                //             })
                //     });
                this.Loqateservice.getLocationId(this.state.postcode)
                    .then(res => {
                        let container = res.data.Items[0]['Id'];
                        let type = res.data.Items[0]['Type'];
                        let postcode = this.state.postcode;
                        return axios.post('/addresses', {postcode, container, type})
                            .then(res => {
                                this.setState({
                                    availableAddresses: res.data.Items,
                                    data: true,
                                    loading: false,
                                    postcodeValid: true,
                                })
                            })
                            .catch(err => {
                                this.setState({
                                    loading: false,
                                    postcodeValid: false,
                                });
                            })
                    });
            } else {
                err.postcode = 'The postcode is not valid';
                this.setState({postcodeValid: false, errors: err, loading: false});
                console.log('not valid postcode');
            }
        } else {
            err.postcode = 'This field is required';
            this.setState({errors: err})
        }
    }

    handlePostcodeChange(e) {
        let value = e.target.value;

        this.setState({
            postcode: value,
            errors: {},
        });
    }

    checkIfUkPostcode () {
        let validatePostcode = new RegExp('([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\\s?[0-9][A-Za-z]{2})');
        let postcode = this.state.postcode;
        return validatePostcode.test(postcode);
    }

    render() {
        console.log('rendering wizard component');
        return (
            <React.Fragment>
                {this.state.data &&
                <section ref={(section) => {
                    this.wizardStart = section;
                }}>
                    <section id="stepper" className='d-none d-sm-block'>
                        <div className="container pt-5">
                            <div className="row justify-content-center mb-3">
                                <h2 className="wizard-heading">Steps</h2>
                            </div>
                            <div className="row">
                                <ul className="nav nav-wizard">
                                    {this.state.steps.map((step, index) => {
                                        let stepClassName = this.state.currentStep === index ? "active" : "";
                                        return (
                                            <li key={index}
                                                className={stepClassName}
                                                onClick={() => this.changeStep(index)}
                                            >

                                                <a role="button" style={{textTransform: 'uppercase', letterSpacing: '1px'}}><span
                                                    className="wizard-number" style={{color: '#514f4c', paddingTop: '5px', fontSize: '150%', fontWeight: '600'}}>{(index + 1)}</span><span style={{paddingTop: '15px', color: '#514f4c', fontWeight: '600'}}>{step.title}</span></a>
                                            </li>);
                                    })}
                                </ul>
                            </div>
                        </div>
                    </section>

                    {this.state.currentStep === 0 &&
                    <Junk
                        globalStateChange={(param) => this.updateState('junkState', param)}
                        updatePrice={() => this.updateOrderPrices()}
                        variation={this.state.current_variation}
                        localState={this.state.junkState}
                        sizes={this.state.sizes}
                        setValidity={(value) => this.setValidity(0, value)}
                        nextStep={() => this.changeStep(this.state.currentStep + 1)}

                        toggleVariationModal={() => this.toggleVariationModal()}
                        changeVariation={() => this.changeVariation()}
                    />
                    }

                    {this.state.currentStep === 1 &&
                    <Size
                        globalStateChange={(param) => this.updateState('sizeState', param)}
                        localState={this.state.sizeState}
                        size={this.state.junkState}
                        variation={this.state.current_variation}
                        modal={() => this.updateModal()}
                        changeVariation={() => this.changeVariation()}
                        updatePrice={() => this.updateOrderPrices()}
                        types={this.state.junkTypes}
                        extras={this.state.extras}
                        setValidity={(value) => this.setValidity(1, value)}
                        nextStep={() => this.changeStep(this.state.currentStep + 1)}
                        prevStep={() => this.changeStep(this.state.currentStep - 1)}
                    />
                    }

                    {this.state.currentStep === 2 &&
                    <Collection
                        globalStateChange={(param) => this.updateState('collectionState', param)}
                        localState={this.state.collectionState}
                        availableAddresses={this.state.availableAddresses}
                        cut_off={this.props.cut_off}
                        setValidity={(value) => this.setValidity(2, value)}
                        arrivals={this.props.arrivals}
                        postcode={this.state.postcode}
                        nextStep={() => this.changeStep(this.state.currentStep + 1)}
                        prevStep={() => this.changeStep(this.state.currentStep - 1)}
                        variation={this.state.current_variation}
                        handlePostcodeChange={this.handlePostcodeChange}
                        loading={this.state.loading}
                        errors={this.state.errors}
                        handleSelectPostcode={this.handleSelectPostcode}
                        postcodeValid={this.state.postcodeValid}
                    />
                    }

                    {this.state.currentStep === 3 &&
                    <HelpOurTeam
                        globalStateChange={(param) => this.updateState('helpState', param)}
                        localState={this.state.helpState}
                        // cut_off={this.props.cut_off}
                        // availableAddresses = {this.state.availableAddresses}
                        changeVariation={() => this.changeVariation()}
                        variation={this.state.current_variation}
                        setValidity={(value) => this.setValidity(3, value)}
                        cut_off={this.props.cut_off}
                        arrivals={this.props.arrivals}
                        size={this.state.junkState}
                        updatePrice={() => this.updateOrderPrices()}
                        postcode={this.state.postcode}
                        nextStep={() => this.changeStep(this.state.currentStep + 1)}
                        prevStep={() => this.changeStep(this.state.currentStep - 1)}
                    />
                    }

                    {this.state.currentStep === 4 &&
                    <Confirmation
                        globalStateChange={(param) => this.updateState('confirmationState', param)}
                        localState={this.state.confirmationState}
                        junk={this.state.junkState}
                        size={this.state.sizeState}
                        variation={this.state.current_variation}
                        collection={this.state.collectionState}
                        help={this.state.helpState}
                        setValidity={(value) => this.setValidity(4, value)}
                        nextStep={() => this.changeStep(this.state.currentStep + 1)}
                        prevStep={() => this.changeStep(this.state.currentStep - 1)}
                    />
                    }

                    {this.state.currentStep === 5 &&
                    <Payment
                        globalStateChange={(param) => this.updateState('companyNumberState', param)}
                        stripe_key={this.props.stripe_key}
                        localState={this.state}
                        prevStep={() => this.changeStep(this.state.currentStep - 1)}
                        paymentError={this.props.paymentError}
                        variation={this.state.current_variation}
                    />
                    }

                    <Modal isOpen={this.state.variation_modal} toggle={this.toggleVariationModal} className='modal-dialog modal-lg modal-dialog-centered' backdrop="static" keyboard={false}>
                        <ModalHeader>Did you know?</ModalHeader>
                        <ModalBody>
                            {/*{this.state.current_variation == 'man_and_van' &&*/}
                            {/*<p>*/}
                            {/*You are about to change 'Man and van' service to 'Skip hire'. This action will reset your wizard progress, and you will be prompted to 1st wizard step.*/}
                            {/*To continue click 'Continue' button below. You can cancel this action and continue with your current order by clicking 'Cancel' button.*/}
                            {/*</p>*/}
                            {/*}*/}

                            {this.state.current_variation == 'skip' &&
                            <React.Fragment>
                                {this.state.currentStep == 0 &&
                                <div className='pt-3'>
                                    <p>The equivalent Man & Van waste collection service is better for environment, faster and costs less. If you decide to switch to our Man & Van waste collection service, your current order to hire a <strong>{this.state.junkState.size ? this.state.junkState.size.size_uk : ''} skip</strong> will change to the Man & Van equivalent option,
                                        which is <strong>{this.state.junkState.size ? this.state.junkState.size.relative.size_uk : ''} cubic yards</strong>.
                                    </p>
                                    <p>
                                        Currently this will save you <strong>&#163;{this.state.junkState.size ? ((+this.state.junkState.size.price) - (+this.state.junkState.size.relative.price)) / 100 : ''}</strong>.
                                    </p>
                                </div>
                                }

                                {/*{this.state.currentStep == 1 &&*/}
                                {/*<div className='row pt-3'>*/}
                                {/*<div className="col-12">*/}
                                {/*<h4>Any extras?</h4>*/}
                                {/*</div>*/}
                                {/*<div className="col-12">*/}
                                {/*<p>If you have any of the following items, please note they cannot be disposed of in a skip and the skip collection may not be completed.</p>*/}
                                {/*</div>*/}
                                {/*<div className="col-sm-10 offset-sm-2">*/}
                                {/*<ul>*/}
                                {/*<li>Fridge/freezers</li>*/}
                                {/*<li>Mattresses</li>*/}
                                {/*<li>TV or monitor</li>*/}
                                {/*<li>Paint tins (not emptied)</li>*/}
                                {/*<li>Car tyres</li>*/}
                                {/*</ul>*/}
                                {/*</div>*/}
                                {/*<div className="col-12">*/}
                                {/*<p>*/}
                                {/*However, we can collect waste that may contain the above items on our Man & Van waste collection service, which is environmentally friendly and generally more cost effective. Click here to switch to our Man & Van service.*/}
                                {/*</p>*/}
                                {/*</div>*/}
                                {/*</div>*/}
                                {/*}*/}

                                {/*{this.state.currentStep > 1 &&*/}
                                {/*<div>*/}
                                {/*<p>Adding extras is now available in step 2 of this wizard</p>*/}
                                {/*</div>*/}
                                {/*}*/}

                                {/*{this.state.currentStep > 2 &&*/}
                                {/*<div>*/}
                                {/*<p>Your personal data from step 3 will stay as it is, but you can always update your details</p>*/}
                                {/*</div>*/}
                                {/*}*/}
                            </React.Fragment>
                            }
                        </ModalBody>
                        <ModalFooter>
                            <button className='btn btn-round py-3 btn-cw btn-back' onClick={this.goNextStep}>{this.state.currentStep == 0 ? 'No, thanks.' : 'Cancel'}</button>
                            <button className='btn btn-round py-3 btn-cw btn-yellow' onClick={this.changeVariationAndGoNext}>{this.state.currentStep == 0 ? 'Let’s switch' : 'Change option'}</button>
                        </ModalFooter>
                    </Modal>
                </section>
                }


                {/*{!this.state.data &&*/}
                {/*<div className="container" style={{height: '80vh', position: 'relative'}}>*/}
                {/*    <div className="row" style={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>*/}
                {/*        <div className="col-12 justify-content-center">*/}
                {/*            <Loader type="Oval" color="#514f4c" height={50} width={50}/>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*}*/}
            </React.Fragment>

        );
    }

    getDefaultState() {
        return {
            data: false,
            variation_modal: false,
            current_variation: this.props.variation,
            order_total: 0,
            sizes: this.props.sizes,
            junkTypes: this.props.junkTypes,
            // extras: this.props.extras,
            postcode: this.props.postcode,
            availableAddresses: {},
            validationError: '',
            currentStep: 0,
            junkState: {
                size: ''
            },
            sizeState: {
                type: '',
                extras: this.props.extras,
                selected_extras: []
            },
            collectionState: {
                address_find: '',
            },
            helpState: {
                arrival: '',
                access: true,
                parking: true
            },
            confirmationState: {
                totalPrice: '',
                address: '',
                coupon: '',
                appliedCoupon: ''
            },
            steps: [
                {
                    title: 'Size',
                    valid: false,
                },
                {
                    title: 'Extras',
                    valid: true,
                },
                {
                    title: 'Details',
                    valid: false,
                },
                {
                    title: 'Collection',
                    valid: false,
                },
                {
                    title: 'Summary',
                    valid: false,
                },
                {
                    title: 'Payment',
                    valid: false,
                }
            ],
            errors: {},
            loading: false,
            postcodeValid: false,
        }
    }

    getStateFromLocalStorage() {
        let state = this.getDefaultState();

        let sessionStorageState = sessionStorage.getItem('wizardState');

        // read state from cookie and parse props here
        if (sessionStorage['wizardState']) {
            sessionStorageState = JSON.parse(sessionStorageState);
            return sessionStorageState;
        }

        return state;
    }
}

if (document.getElementById('rWizard')) {
    let element = document.getElementById('rWizard');
    ReactDOM.render(<Wizard
        sizes={JSON.parse(element.dataset.sizes)}
        junkTypes={JSON.parse(element.dataset.types)}
        extras={JSON.parse(element.dataset.extras)}
        arrivals={JSON.parse(element.dataset.arrivals)}
        postcode={element.dataset.postcode}
        stripe_key={element.dataset.stripe_key}
        cut_off={element.dataset.cut_off}
        variation={element.dataset.variation}
        paymentError={element.dataset.payment_error}
    />, element);
}

export default Wizard;
